<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row class="mb-12">
        <dgx-components-grid-column [xs]="12">
          <checkout-progression-steps />
        </dgx-components-grid-column>
      </dgx-components-grid-row>

      <dgx-components-grid-row class="mb-12">
        <dgx-components-grid-column [md]="6" [xs]="12">
          <h1 class="typog-h2 mb-6">
            {{ vm.cmsData.pageTitle }}
          </h1>

          <checkout-customer-details class="mb-6" />

          <checkout-payment-method-form (submitted)="cs.onFormSubmit($event)" />
        </dgx-components-grid-column>

        <dgx-components-grid-column [md]="1" />

        <dgx-components-grid-column [md]="5" [xs]="12">
          <div class="payment-method__aside">
            <dgx-basket-summary [canRemoveSelectedQuotes]="false" />
          </div>
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
